exports.ValidateName=(name)=>{
    name = name && name.trim();
    var fullNamePattern =/^(?![0-9._ ]*$)[a-zA-Z0-9._"' ]+$/;
    let fullName=[];
    if(name.includes(" ")) {
        fullName = name.split(" ");
    }
    let err = "";
    if(name.length<3) {
        err = 'Your name must be greater than 2 characters.';
    }else if(name.length>20) {
        err =  'Your name must have 20 characters or less.';
    }else if(!fullNamePattern.test(String(name).toLowerCase())){
        err =  'Enter Valid Name';
    }
    else if(fullName.length>0) {
        fullName.forEach((nm)=>{
            if(nm.length>2) {
                if (!fullNamePattern.test(String(nm).toLowerCase())) {
                    err = 'Each word must contain at least 1 letter.';
                }
            }
        })

    }
    return err;
};

exports.validateUserName=(name)=>{
    name = name && name.trim();
    var userNamePattern =/^(?![0-9._ ]*$)[a-zA-Z0-9._]+$/;
    let err = "";
    if(name.length<4) {
        err = 'User name must be greater than 3 characters.';
    }else if(name.length>15) {
        err =  'User name must have 15 characters or less.';
    }
    else if(name.includes(" ")) {
        err =  'User name can not have Space.';
    }
    else if (!/[a-z]+/g.test(name.toLowerCase())) {
        err = "User name must contain at least one letter.";
    }
    else if(!userNamePattern.test(String(name).toLowerCase())){
        err =  'User name can only have numbers and characters. Cannot contain special characters.';
    }
    return err;
};

exports.validatePassword=(password)=>{
    password = password && password.trim();
    let err = "";
    if(password.length<6) {
        err = 'Your password must be greater than 6 characters.';
    }else if(password.length>16) {
        err =  'Your password must have 16 characters or less.';
    }
    else if(password.includes(" ")){
        err =  'Password must not have space.';
    }
    return err;
};


exports.validateEmail=(email)=> {
    email = email && email.trim();
    let emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(email==='')
        return 'Must Enter Email.';
    else if(!emailPattern.test(String(email).toLowerCase()))
        return 'Must be valid Email Format.';
    else
        return '';
};
exports.validateDate=(date)=>{
    let val = date.split('/');
    let d=Number(val[0]);
    let m=Number(val[1]);
    let y=Number(val[2]);
  let today=new Date();
    var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    if(y === today.getFullYear() || y === today.getFullYear()+1 ) {
      if (m === 1 || m > 2 || m < 12) {
        if (d > ListofDays[m - 1]) {
          return false
        }
        if (m === 2) {
          let lyear = false
          if ((!(y % 4) && y % 100) || !(y % 400)) {
            lyear = true
          }
          if ((lyear === false) && (d >= 29)) {
            return false
          }
          if ((lyear === true) && (d > 29)) {
            return false
          }
        }
        else if (m > 12) {
          return false;
        }
        else {
          return true;
        }
      }
    }
    else{
     return false;
    }

};